var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgColorSchemeWhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 21.2144C13.0615 22.1645 14.4633 22.7422 16 22.7422C19.3137 22.7422 22 20.0559 22 16.7422C22 13.9753 20.1271 11.6458 17.5798 10.9524M6.42018 10.9523C3.87293 11.6458 2 13.9753 2 16.7422C2 20.0559 4.68629 22.7422 8 22.7422C11.3137 22.7422 14 20.0559 14 16.7422C14 15.9617 13.851 15.216 13.5798 14.532M18 8.74219C18 12.0559 15.3137 14.7422 12 14.7422C8.68629 14.7422 6 12.0559 6 8.74219C6 5.42848 8.68629 2.74219 12 2.74219C15.3137 2.74219 18 5.42848 18 8.74219Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgColorSchemeWhite);
export default __webpack_public_path__ + "static/media/color-scheme-white.a3e835e6aabe6ad6bc5ba9f0f8d98a30.svg";
export { ForwardRef as ReactComponent };